import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import './index.css';
import "bootstrap/dist/css/bootstrap.min.css";
import { registerServiceWorker } from "./utils/serviceWorkerRegistration";
import "./i18n";

async function initializeAndRender() {
  try {
    // Unregister any existing service workers to prevent reload loops
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => {
          registration.unregister().then((success) => {
            if (success) {
              console.log('[Service Worker] Unregistered existing service worker');
            }
          });
        });
      });
    }
    
    const root = ReactDOM.createRoot(document.getElementById("root")!);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
    
    // Register service worker for PWA (only in production)
    registerServiceWorker();
  } catch (error) {
    console.error("Error initializing app:", error);
  }
}

initializeAndRender();